import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20hero%20background%20abstract%20geometric%20shapes%20with%20warm%20gradient%20colors%20orange%20and%20coral%20tones%20digital%20entertainment%20vibe%20soft%20glowing%20particles%20cinematic%20atmosphere%20dark%20elegant%20background%20with%20play%20button%20motif&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="茄子视频 - 高清在线观看平台"
        title="茄子视频 - 高清免费在线观看"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white font-bold mb-4 md:mb-6 tracking-wide">
          {heroData.headline}
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {heroData.subheadline}
        </p>
        <div className="flex items-center justify-center gap-4 flex-col sm:flex-row">
          <Link
            to={heroData.ctaLink}
            className="px-8 py-3 md:px-10 md:py-3.5 rounded-full bg-primary-500 text-white text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200 hover:scale-105"
          >
            <i className="ri-play-circle-line mr-2"></i>
            {heroData.ctaText}
          </Link>
          <Link
            to={heroData.secondaryLink}
            className="px-8 py-3 md:px-10 md:py-3.5 rounded-full border-2 border-white/40 text-white text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-white/10 hover:border-white/60 transition-all duration-200"
          >
            {heroData.secondaryText}
          </Link>
        </div>
      </div>
    </section>
  );
}